import React from 'react';
import Skeleton from '@/components/ui/Skeleton/Skeleton';

const StatusBoxSkeleton = () => (
  <>
    <Skeleton height="tw-h-5" width="tw-w-40" />
    <div className="tw-flex tw-justify-between tw-flex-col xl:tw-flex-row tw-mt-2">
      <div className="tw-flex tw-flex-col tw-gap-2">
        <Skeleton height="tw-h-3" width="tw-w-14" />
        <Skeleton height="tw-h-4" width="tw-w-24" />
        <Skeleton height="tw-h-3" width="tw-w-32" />
        <div className="tw-mt-2 tw-flex tw-flex-col tw-gap-1">
          <Skeleton height="tw-h-3" width="tw-w-16" />
          <Skeleton height="tw-h-3" width="tw-w-36" />
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-items-end tw-gap-2 tw-mt-4 xl:tw-mt-0">
        <Skeleton height="tw-h-6" width="tw-w-16" />
      </div>
    </div>
  </>
);

export default StatusBoxSkeleton;
